import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/channel/loading-2.gif';

const _withScopeId = n => (_pushScopeId("data-v-4861b8ce"), n = n(), _popScopeId(), n);

const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "loading",
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "tips"
}, "加载中", -1));

const _hoisted_3 = {
  key: 1,
  class: "tips"
};
import { ref, watch } from 'vue';
import { useVModel, useIntersectionObserver } from '@vueuse/core';
export default {
  props: {
    // 是否处于加载中
    modelValue: {
      type: Boolean,
      required: true
    },
    // 是否已经加载完
    isFinished: {
      type: Boolean,
      default: false
    },
    // 加载完成提示
    finishText: {
      type: String,
      default: '没有更多了'
    }
  },
  emits: ['onLoad', 'update:modelValue'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const loading = useVModel(props);
    const loadingTarget = ref(null); // 记录是否在底部

    const targetIsIntersecting = ref(false);
    useIntersectionObserver(loadingTarget, ([{
      isIntersecting
    }]) => {
      targetIsIntersecting.value = isIntersecting;
      emitLoad();
    }); // 触发load

    const emitLoad = () => {
      setTimeout(() => {
        // 可见 & loading 为 false & 数据没有加载完
        if (targetIsIntersecting.value && !loading.value && !props.isFinished) {
          loading.value = true;
          emits('onLoad');
        }
      }, 100);
    }; // 监听 loading 变化


    watch(loading, emitLoad);
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", null, [_renderSlot(_ctx.$slots, "default"), _createElementVNode("div", {
        ref_key: "loadingTarget",
        ref: loadingTarget,
        class: "infinite"
      }, [!__props.isFinished ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_hoisted_1, _hoisted_2], 64)) : _createCommentVNode("", true), __props.isFinished ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.finishText), 1)) : _createCommentVNode("", true)], 512)]);
    };
  }

};